import React from "react";
import style from "./List.module.css";
import OneOffer from "./OneOffer/OneOffer";
import { useDispatch, useSelector } from "react-redux";
import {
  CompanyType,
  findById,
  selectCompanies,
} from "../../../../slices/company/companySlice";
import { Link, useLocation } from "react-router-dom";
import { RootState } from "../../../../app/store";
import Spinner from "../../../../stuffs/Spinner/Spinner";

const List: React.FC = () => {
  const companies: CompanyType[] = useSelector(selectCompanies);
  const isLoading = useSelector((state: RootState) => state.companies.isLoading);
  const location = useLocation();

  const pathParts = location.pathname.split("/").filter(Boolean);

  const voivodeship = pathParts[0] || "All";
  const truck = pathParts[1] || "All";

  const isExactTop3View =
  voivodeship !== "All" &&
  truck !== "All";

  

  if (isLoading) {
    return (
      <div className={style.Content}>
        <Spinner />
      </div>
    );
  }

  if (!isLoading && companies.length === 0) {
    return (
      <div className={style.Content}>
        <p>Brak wyników.</p>
      </div>
    );
  }
  return (
    <div className={style.Content}>
      {companies.map((offer: CompanyType) => {

        const now = new Date();
        
        const showRecommended =
          isExactTop3View &&
          !!offer.recommendedExpirationDate &&
          new Date(offer.recommendedExpirationDate) > now;

        const showHighlighted =
          (!!offer.highlightedExpirationDate &&
            new Date(offer.highlightedExpirationDate) > now) ||
          (!!offer.recommendedExpirationDate &&
            new Date(offer.recommendedExpirationDate) > now);

        const displayedMainField =
          truck !== "All"
            ? truck
            : offer.mainField?.[0] || "";

        return (
          <Link
            className={style.Link}
            key={offer._id}
            to={`/offer/${offer._id}`}
          >
            <OneOffer
              name={offer.name}
              shortName={offer.shortName}
              website={offer.website}
              email={offer.email}
              phone={offer.phone}
              NIP={offer.NIP}
              description={offer.description}
              mainField={displayedMainField}
              isHighlighted={showHighlighted}
              isRecommended={showRecommended}
              voivodeship={offer.voivodeship}
            />
          </Link>
        );
      })}
    </div>
  );
};

export default List;